import React from 'react';
import { AuthWrapper } from '@src/features/auth/components';
import { useActivateUser } from '@src/features/auth/hooks';
import { ArcButton, ArcStack, ArcText } from '@src/core/ui';

const ActivateUserPage: React.FC = () => {
  const { onActivate, isLoading } = useActivateUser();

  return (
    <AuthWrapper>
      <ArcStack spacing={3}>
        <ArcText.h4 textAlign='center'>Please click on the activation link below to activate your profile</ArcText.h4>
        <ArcButton.brand isLoading={isLoading} onClick={onActivate}>
          Activate
        </ArcButton.brand>
      </ArcStack>
    </AuthWrapper>
  );
};

export default ActivateUserPage;